module.exports = __webpack_public_path__ + "static/img/13.0d5cc74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/13.jpg
// module id = Juz5
// module chunks = 15